import { Component, Input, ViewChild } from '@angular/core'
import { NgbModal, NgbNav } from '@ng-bootstrap/ng-bootstrap'
import { IDataCardSDL } from '../../../../../models/data-card.model'
import { NotificationsDataCardModalComponent } from '../../cmms-components/notifications-data-card-modal/notifications-data-card-modal.component'

@Component({
    selector: 'app-data-sdl',
    templateUrl: './data-sdl.component.html',
    standalone: false
})
export class DataSdlComponent {
  @ViewChild('nav') private nav: NgbNav
  @Input() data: IDataCardSDL
  @Input() filter?: {startTime?: string; endTime?: string}
  @Input() hasCMMSPackage: boolean = false

  constructor(private modalService: NgbModal) {}

  public onOpenNotificationModal(tag: string, notifications?: number): void {
    if (!notifications) {
      return
    }

    const modalRef = this.modalService.open(NotificationsDataCardModalComponent, {
      windowClass: 'cmms-notification-modal-z2000',
      backdropClass: 'cmms-notification-backdrop-z2000',
    })
    modalRef.componentInstance.mainObject = tag
  }
}
